import { createAsyncThunk } from '@reduxjs/toolkit';

import { getActiv8ContentId } from '../../activ8/story/media/storyMediaItem';
import { STORY_MEDIA_SOURCE } from '../../activ8/story/media/storyMediaSources';
import getMediaTypeByFilename from '../../utils/getMediaTypeByFilename';
import { downloadActiv8MediaDisplay } from '../activ8/activ8Actions';
import { downloadFavoriteMediaBuffer } from '../ai-studio/aiStudioActions';

const GET_STORY_MEDIA_STUDIO_PAYLOAD = 'story/GET_STORY_MEDIA_STUDIO_PAYLOAD';

const toStoryMediaStudioPayload = (arrayBuffer, fileName, mediaType) => {
  const resolvedFileName = fileName || 'media';

  return {
    arrayBuffer,
    fileName: resolvedFileName,
    mediaType: mediaType || getMediaTypeByFilename(resolvedFileName),
  };
};

export const getStoryMediaStudioPayload = createAsyncThunk(
  GET_STORY_MEDIA_STUDIO_PAYLOAD,
  async ({ media }, { dispatch, rejectWithValue }) => {
    const { source, sourceId, link, fileName, type } = media;

    if (link) {
      const response = await fetch(link);

      if (!response.ok) {
        return rejectWithValue('Failed to fetch media');
      }

      return toStoryMediaStudioPayload(await response.arrayBuffer(), fileName, type);
    }

    if (source === STORY_MEDIA_SOURCE.ACTIV8) {
      const result = await dispatch(downloadActiv8MediaDisplay({ contentId: getActiv8ContentId(media) }));

      if (downloadActiv8MediaDisplay.rejected.match(result)) {
        return rejectWithValue(result.payload);
      }

      const { arrayBuffer, fileName: resolvedFileName } = result.payload;

      return toStoryMediaStudioPayload(arrayBuffer, resolvedFileName || fileName, type);
    }

    if (source === STORY_MEDIA_SOURCE.FAVORITE) {
      const result = await dispatch(downloadFavoriteMediaBuffer({ id: sourceId }));

      if (downloadFavoriteMediaBuffer.rejected.match(result)) {
        return rejectWithValue(result.payload);
      }

      const { arrayBuffer, fileName: resolvedFileName } = result.payload;

      return toStoryMediaStudioPayload(arrayBuffer, resolvedFileName || fileName, type);
    }

    return rejectWithValue('Unsupported media source');
  },
);
